import parentApi from '../store/parentApi';

const feedbackApis = parentApi.injectEndpoints({
  endpoints: (build) => ({
    submitFeedback: build.mutation({
      query: ({ category, message, image_id }) => ({
        url: '/api/surge/feedbacks',
        method: 'POST',
        body: { feedback: { category, message, ...(image_id ? { image_id } : {}) } },
      }),
      invalidatesTags: (result) => (result ? ['tenant-config'] : []),
    }),
  }),
});

export const { useSubmitFeedbackMutation } = feedbackApis;
